import { render } from "./KnowUniv.vue?vue&type=template&id=602204f4&scoped=true"
import script from "./KnowUniv.vue?vue&type=script&lang=js"
export * from "./KnowUniv.vue?vue&type=script&lang=js"

import "./KnowUniv.vue?vue&type=style&index=0&id=602204f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-602204f4"

export default script